import { StarsMismatchCtrl } from './stars-mismatch.controller';

export const StarsMismatchStepComponent = {
  controller: StarsMismatchCtrl,
  bindings: {
    prevStep: '&',
    nextStep: '&',
  },
  template: require('./stars-mismatch.html'),
};
